import { Popper } from '@mui/material';
import styled from 'styled-components';
//Popper style can not be changed via src\themes\theme.ts
export const PopperZIndex = styled(Popper) `
  && {
    z-index: 999;
  }
`;
